/* eslint-disable no-extend-native */
import getOr from 'lodash/fp/getOr';
import find from 'lodash/find';

import { validCountries } from '../global/validCountries';
import { getCurrentUser } from './firebase';
import { LocalStorage } from '../models/LocalStorage';
import { GLOBAL_CONSTANTS } from '../global/constants';
import { ROOT_GLOBAL } from '../global/root';
const queryString = require('query-string');

export const ELEMENT_TYPE = {
  GENERAL: "general",
  BUTTON: "Button",
  A: "A",
  SPAN: "Span",
  DIV: "Div",
  P: "P",
  INPUT: "Input",
  SELECT: "Select",
  NAV: "Nav",
  PROFILE: "profile",
  CARD: "card",
  IMG: "img",
  SECTION: "section"
}

const DURATION = 3000;
const CB_DURATION = 3000;
const MTT = 1;
export class Track {
  constructor(id, elementType, page, section, cId, duration, cbDuration, maxTrackTime) {
    this.id = id;
    this.p = page || window.location.pathname;
    this.sec = section;
    this.t = elementType;
    this.rid = getCookie("_foeid");
    this.cid = cId;
    this._ntd = duration;
    this._ptd = cbDuration;
    this._mtt = maxTrackTime;
    this.uid = LocalStorage.getUserId();
    this.pl = window.outerWidth < 1024 ? "mobile-web" : "web";
    this.cur = "USD";
    this.l = navigator.language;
  }

  static genNormalTrack(page = "", section, id = "", elementType = ELEMENT_TYPE.GENERAL, categoryId = "", duration = DURATION, cbDuration = CB_DURATION, maxTrackTime = MTT) {
    return JSON.stringify(new Track(id, elementType, page, section, categoryId, duration, cbDuration, maxTrackTime));
  }
}

export function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export function isLoggedIn() {
  return !!getCurrentUser();
}

// set local data (local variable and session storage and local storage)
export function setLocalStorage(type, value) {
  if (value !== undefined && value !== null) {
    if (localStorage && localStorage.length) {
      localStorage.setItem(type, value);
    }
  } else {
    if (localStorage && localStorage.length) {
      localStorage.removeItem(type);
    }
  }
}

export function getLocalInfo(type) {
  if (localStorage && localStorage.length) {
    return localStorage.getItem(type);
  } else {
    return null;
  }
}

export function getGaClientId() {
  const id = getCookie("_ga");
  if (id) {
    return id;
  }
  let result = "";
  try {
    const trackers = window.ga.getAll();
    if (trackers.length > 0) {
      result = trackers[0].get('clientId');
    }
  } catch {

  }
  // if (!result) {
  //   result = getCookie("_foeid");
  // }
  return result;
}

export function isMobile() {
  return window.outerWidth < 768;
}

export function nFormatter(num, digits = undefined, unit = "") {
  const si = [
    { value: 1, symbol: "" },
    { value: 1E3, symbol: "K" },
    { value: 1E6, symbol: "M" },
    { value: 1E9, symbol: "B" },
    { value: 1E12, symbol: "T" },
    { value: 1E15, symbol: "Qa" },
    { value: 1E18, symbol: "Qi" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; i--) {
    if (num * 1 >= si[i].value) {
      break;
    }
  }
  return unit + (num / si[i].value).toFixed(digits !== undefined ? digits : i * 3).replace(rx, "$1") + (si[i].symbol ? " " : "") + si[i].symbol;
}

export function historyPushState(newurl, isReplace = false) {
  if (window.location.pathname + window.location.search !== newurl) {
    if (window.history.pushState) {
      if (isReplace && window.history.replaceState) {
        window.history.replaceState({ path: newurl }, '', newurl);
      } else {
        window.history.pushState({ path: newurl }, '', newurl);
      }
    } else {
      window.location.href(newurl);
    }
  }
}

export function getParamUrl(name, source = window.location.search) {
  const data = queryString.parse(source);
  return name ? getOr(undefined, name)(data) : data;
}

export function solveUrlParams(params, getRaw = false) {
  let result = "";
  result = getRaw ? queryString.stringify(params) : "?" + queryString.stringify(params);
  if (result === "?") {
    result = "";
  }
  return result;
}

export function genEndPointGetParam(endPoint = "", param = null) {
  const result = (!!endPoint && typeof (endPoint) === "string" ? endPoint : "/");
  return result + solveUrlParams(param);
}

export function scrollTo(selector, distance = 40, duration = 1000) {
  window.$('html, body').animate({
    scrollTop: window.$(selector).offset().top - distance
  }, 1000);
}

export function growingTextArea() {
  /**
   * Auto-growing textareas; technique ripped from Facebook
   * 
   * 
   * http://github.com/jaz303/jquery-grab-bag/tree/master/javascripts/jquery.autogrow-textarea.js
   */
  window.$.fn.autogrow = function (options) {
    return this.filter('textarea').each(function () {
      var self = this;
      var $self = window.$(self);
      var minHeight = $self.height();
      var noFlickerPad = $self.hasClass('autogrow-short') ? 0 : parseInt($self.css('lineHeight')) || 0;
      var settings = window.$.extend({
        preGrowCallback: null,
        postGrowCallback: null
      }, options);

      var shadow = window.$('<div></div>').css({
        position: 'absolute',
        top: -10000,
        left: -10000,
        width: $self.width(),
        fontSize: $self.css('fontSize'),
        fontFamily: $self.css('fontFamily'),
        fontWeight: $self.css('fontWeight'),
        lineHeight: $self.css('lineHeight'),
        resize: 'none',
        'word-wrap': 'break-word'
      }).appendTo(document.body);

      var update = function (event) {
        var times = function (string, number) {
          for (var i = 0, r = ''; i < number; i++) r += string;
          return r;
        };

        var val = self.value.replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\n$/, '<br/>&#xa0;')
          .replace(/\n/g, '<br/>')
          .replace(/ {2,}/g, function (space) { return times('&#xa0;', space.length - 1) + ' ' });

        // Did enter get pressed?  Resize in this keydown event so that the flicker doesn't occur.
        if (event && event.data && event.data.event === 'keydown' && event.keyCode === 13) {
          val += '<br />';
        }

        shadow.css('width', $self.width());
        shadow.html(val + (noFlickerPad === 0 ? '...' : '')); // Append '...' to resize pre-emptively.

        var newHeight = Math.max(shadow.height() + noFlickerPad, minHeight);
        if (settings.preGrowCallback != null) {
          newHeight = settings.preGrowCallback($self, shadow, newHeight, minHeight);
        }

        $self.height(newHeight);

        if (settings.postGrowCallback != null) {
          settings.postGrowCallback($self);
        }
      }

      $self.change(update).keyup(update).keydown({ event: 'keydown' }, update);
      window.$(window).resize(update);

      update();
    });
  };
}

export function validateEmail(mail) {
  // eslint-disable-next-line no-useless-escape
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail.trim())) {
    return true;
  }
  return false;
}

export function validatePassword(password, compare) {
  // return password && password.match(/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[0-9]){6,}$/);
  return password && password.length > 5 && (!compare || compare === password);
}


export function validatePhone(phone) {
  const regex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
  return typeof phone == "string" ? regex.test(phone) : phone.getNumber() && phone.isValidNumber();
}

export function validatePhoneEmpty(phone) {
  return !phone || !phone.getNumber() || (phone.getNumber() && phone.isValidNumber());
}

export function validateCode(code) {
  return code && code.length >= 6;
}

export function validateOrderValue(value) {
  return (value + "").replace(/,/g, "") * 1 >= 0;
}

export function selectSearchPlaceholder() {
  const Defaults = window.$.fn.select2.amd.require('select2/defaults');

  window.$.extend(Defaults.defaults, {
    searchInputPlaceholder: ''
  });

  const SearchDropdown = window.$.fn.select2.amd.require('select2/dropdown/search');

  const _renderSearchDropdown = SearchDropdown.prototype.render;

  SearchDropdown.prototype.render = function (decorated) {

    // invoke parent method
    const $rendered = _renderSearchDropdown.apply(this, Array.prototype.slice.apply(arguments));

    this.$search.attr('placeholder', this.options.get('searchInputPlaceholder'));

    return $rendered;
  };
}

export function validate(selector, validator = function (data) { return !!data; }, ignore = false, showInvalid = true, customVal = undefined, compare) {
  const element = window.$(selector);
  if (!validator(customVal !== undefined ? customVal : (element.val() && element.val().trim()), compare) && !ignore) {
    if (showInvalid) {
      element.addClass("is-invalid");
      element.focus();
    }
    return false;
  } else {
    element.removeClass("is-invalid");
    return true;
  }
}

export function clearableInput() {
  // window.$(".clearable").each(function () {
  //   const $inp = window.$(this).find("input:text"), $cle = window.$(this).find(".clearable__clear");
  //   $inp.on("input", function () {
  //     $cle.toggle(!!this.value);
  //   });
  //   $cle.on("touchstart click", function (e) {
  //     e.preventDefault();
  //     $inp.val("").trigger("input");
  //   });
  // });
  // window.$.ui.autocomplete.prototype._resizeMenu = function () {
  //   const ul = this.menu.element;
  //   ul.outerWidth(this.element.outerWidth());
  // }

  window.$('body').on('focus', 'input', function (e) {
    window.$(this)
      .one('mouseup', function () {
        window.$(this).select();
        return false;
      })
      .select();
  });
}

export function getCountryDetail(code) {
  return find(validCountries.data, function (o) { return o.code * 1 === code * 1 || o.iso2 === code || o.iso3 === code; }) || {};
}

export function getPrice(value) {
  let result = (value + "").replace(/,/g, "") * 1;
  return isNaN(result) ? 0 : result;
}

export function getH6(hs = "") {
  return hs.length > 6 ? hs.substring(0, 6) : hs;
}
String.prototype.asciifolding = function () {
  var from = "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ",
    to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
  var str = this.toLowerCase().trim()
  for (var i = 0, l = from.length; i < l; i++) { str = str.replace(RegExp(from[i], "gi"), to[i]); }
  return str;
}

String.prototype.ngram_highlight = function (sentence, options) {
  if (sentence.trim() === "") {
    return this + "";
  }
  if (!options) {
    options = {}
  }
  if (!options.pre_tag) {
    options.pre_tag = '<pre>';
  }
  if (!options.post_tag) {
    options.post_tag = '</pre>';
  }
  var asciifoldingTxt = this.asciifolding();
  var replacements = [];
  var words = sentence.split(" ");
  var compared = {};
  for (let idx in words) {
    var t = asciifoldingTxt;
    var word = words[idx];
    if (word.trim() === "") {
      continue;
    }
    var asciifoldingWord = word.asciifolding();
    if (compared[asciifoldingWord]) {
      continue;
    }
    compared[asciifoldingWord] = true;
    var asciifoldingWordLen = asciifoldingWord.length;
    var startPos = 0;
    while (true) {
      var pos = t.indexOf(asciifoldingWord);
      if (pos === -1) {
        break
      }
      replacements.push({ pos: startPos + pos, len: asciifoldingWordLen });
      t = t.substr(pos + asciifoldingWordLen);
      startPos = startPos + pos + asciifoldingWordLen;
    }
  }
  replacements = replacements.sort(function (a, b) { return (a.pos > b.pos) ? 1 : ((b.pos > a.pos) ? -1 : 0) })
  var selectedReplacements = {};
  var selectedPos = [];
  var replacementsLen = replacements.length;
  for (let i = 0; i < replacementsLen; i++) {
    var currentReplacement = replacements[i];
    var startI = i;
    for (let j = i + 1; j < replacementsLen; j++) {
      if (currentReplacement.pos === replacements[j].pos) {
        if (currentReplacement.len <= replacements[j].len) {
          currentReplacement = replacements[j];
        }
        startI = startI + 1;
      } else if (currentReplacement.pos < replacements[j].pos && replacements[j].pos <= (currentReplacement.pos + currentReplacement.len)) {
        startI = startI + 1;
        continue;
      } else {
        break;
      }
    }
    selectedReplacements[currentReplacement.pos] = currentReplacement;
    selectedPos.push(currentReplacement.pos);
    i = startI;
  }
  let result = this + "";
  for (let i = selectedPos.length - 1; 0 <= i; i--) {
    var replacement = selectedReplacements[selectedPos[i]];
    result = result.substr(0, replacement.pos) + options.pre_tag + result.substr(replacement.pos, replacement.len) + options.post_tag + result.substr(replacement.pos + replacement.len);
  }
  return result;
}

String.prototype.word_highlight = function (sentence, options) {
  if (sentence.trim() === "") {
    return this + "";
  }
  if (!options) {
    options = {}
  }
  if (!options.pre_tag) {
    options.pre_tag = '<pre>';
  }
  if (!options.post_tag) {
    options.post_tag = '</pre>';
  }
  var tWords = this.split(" ");
  var words = sentence.split(" ");
  for (var idx in words) {
    var word = words[idx];
    if (word.trim() === "") {
      continue;
    }
    var asciifoldingWord = word.asciifolding();
    for (var i in tWords) {
      if (tWords[i] !== "" && tWords[i].asciifolding() === asciifoldingWord) {
        tWords[i] = options.pre_tag + tWords[i] + options.post_tag;
      }
    }
  }
  var result = "";
  for (let i in tWords) {
    result = result + tWords[i] + " ";
  }
  return result;
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getTierFromCode(code) {
  let result = GLOBAL_CONSTANTS.PLANS.free;
  Object.keys(GLOBAL_CONSTANTS.PLANS).forEach(key => {
    if (code * 1 === GLOBAL_CONSTANTS.PLANS[key].id) {
      result = GLOBAL_CONSTANTS.PLANS[key];
    }
  });
  return result;
}

export function writeHS(str) {
  let result = '';
  for (let i = 0; i < (str + "").length; i++) {
    result += (str + "")[i];
    if (i % 2 === 1 && i < (str + "").length - 1) {
      result += " ";
    }
  }
  return result;
}

export function removeZeroHS(str) {
  return (str + "").replace(/000000$/, '').replace(/0000$/, '').replace(/00$/, '');
}

(function ($) {
  if ($) {
    $.fn.pagefade = function (fadein, fadeout) {
      this.css("display", "none");
      this.fadeIn(fadein);
      return this;
    };
  }
}(window.jQuery));


export function formatCurrency(amount) {
  if (isNaN(amount)) return "0"; // Xử lý nếu input không phải số
  return Number(amount)
    .toFixed(2) // Làm tròn đến 2 chữ số thập phân
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") // Thêm dấu chấm phân cách nhóm nghìn
    .replace(".", ","); // Chuyển dấu chấm của phần thập phân thành dấu phẩy
}

export function convertMarkdownToHTML(markdown) {
  return markdown
    .replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
}

export function isOverflowing(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

export function triggerSelectionAndClick(element) {
  if (!element) return;

  const range = document.createRange();

  // Đảm bảo phần tử có nội dung văn bản
  if (element.firstChild) {
    range.setStart(element.firstChild, 0);
    range.setEnd(element.firstChild, 0);
  }
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);

  window.$(element).trigger("click");
}



export function typeWriterAnimtion(dataText, element, delay = 700) {
  // array with texts to type in typewriter
  if (typeof dataText == "string") {
    dataText = [dataText];
  }

  // type one text in the typwriter
  // keeps calling itself until the text is finished
  function typeWriter(text, i, fnCallback) {
    // chekc if text isn't finished yet
    if (i < (text.length)) {
      // add next character to h1
      window.$(element).append(text.substring(0, i + 1) + '<span aria-hidden="true"></span>');

      // wait for a while and call this function again for next character
      setTimeout(function () {
        typeWriter(text, i + 1, fnCallback)
      }, 50);
    }
    // text finished, call callback if there is a callback function
    else if (typeof fnCallback == 'function') {
      // call callback after timeout
      setTimeout(fnCallback, 700);
    }
  }
  // start a typewriter animation for a text in the dataText array
  function StartTextAnimation(i) {
    // if (typeof dataText[i] == 'undefined') {
    //   setTimeout(function () {
    //     StartTextAnimation(0);
    //   }, 20000);
    // }
    // check if dataText[i] exists
    if (i < dataText[i]?.length) {
      // text exists! start typewriter animation
      typeWriter(dataText[i], 0, function () {
        // after callback (and whole text has been animated), start next text
        StartTextAnimation(i + 1);
      });
    }
  }
  // start the text animation
  StartTextAnimation(0);
}

export function convertMarkdownToHTML_2(markdown) {
  // 1) Tách theo dòng
  const lines = markdown.split('\n');

  let htmlOutput = '';
  let inList = false; // Theo dõi trạng thái đang ở trong <ul> hay chưa

  // Hàm phụ để đóng thẻ <ul> nếu đang mở
  function closeListIfOpen() {
    if (inList) {
      htmlOutput += '</ul>';
      inList = false;
    }
  }

  // Lặp qua từng dòng
  for (let i = 0; i < lines.length; i++) {
    let line = lines[i].trim();

    // Bỏ qua dòng trống
    if (line === '') {
      // Nếu đang trong <ul>, đóng lại
      closeListIfOpen();
      continue;
    }

    // 2) Check xem là heading hay bullet hay text thường
    // -- Heading cấp 2: "##"
    if (line.startsWith('## ')) {
      // Đóng <ul> nếu đang mở
      closeListIfOpen();
      const content = line.slice(3).trim(); // Bỏ "## "
      htmlOutput += `<h2>${content}</h2>`;
      continue;
    }
    // -- Heading cấp 1: "#"
    else if (line.startsWith('# ')) {
      closeListIfOpen();
      const content = line.slice(2).trim(); // Bỏ "# "
      htmlOutput += `<h1>${content}</h1>`;
      continue;
    }
    // -- Bullet point: "- " hoặc "* "
    else if (line.startsWith('- ') || line.startsWith('* ')) {
      // Mở <ul> nếu chưa mở
      if (!inList) {
        htmlOutput += '<ul>';
        inList = true;
      }
      // Bỏ ký tự đầu ("- " hoặc "* ")
      const content = line.substring(2).trim();
      // Thay thế bold/italic trong content
      const processedContent = processInlineFormatting(content);
      htmlOutput += `<li>${processedContent}</li>`;
    }
    // -- Text thường
    else {
      // Đóng <ul> nếu đang mở
      closeListIfOpen();
      const processedContent = processInlineFormatting(line);
      htmlOutput += `<p>${processedContent}</p>`;
    }
  }

  // Kết thúc, nếu còn <ul> chưa đóng, đóng lại
  closeListIfOpen();

  return htmlOutput;
}

/**
 * Hàm xử lý in đậm, in nghiêng trong một đoạn text
 * - Tìm và thay thế **...** thành <b>...</b>
 * - Tìm và thay thế *...* thành <i>...</i>
 */
function processInlineFormatting(text) {
  // In đậm: **text**
  // Dùng regex gọn ghẽ thay thế:
  //  - /(\*\*)(.*?)\1/g => Tìm **(...)**
  //  - $2 => nội dung bên trong (group 2)
  text = text.replace(/(\*\*)(.*?)\1/g, '<b>$2</b>');

  // In nghiêng: *text*
  // Dùng regex:
  //  - /(\*)(.*?)\1/g => Tìm *(...)*
  //  - $2 => nội dung bên trong (group 2)
  text = text.replace(/(\*)(.*?)\1/g, '<i>$2</i>');

  return text;
}

export function getRedirectURL(redirectUrl, installUrl, shoppingUrl) {
  let installed = false, shopping = false;
  let result = "";

  if (installUrl && installUrl !== "undefined") {
    if (installed) {
      if (shoppingUrl && shoppingUrl !== "false") {
        if (typeof (shoppingUrl) === "string" && shoppingUrl !== "true" && shopping + "" !== "true" && shopping + "" !== "undefined") {
          result = shoppingUrl;
        } else {
          result = shopping ? ROOT_GLOBAL.CHECKOUT + "/" + shopping : redirectUrl;
        }
      } else {
        result = redirectUrl;
      }
    } else {
      result = installUrl;
    }
  } else {
    result = redirectUrl;
  }

  return result;
}